module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation10.4ea8d09f.png";